export const PAYMENT_STATUSES = {
  UNAPPROVED: "UNAPPROVED",
  PAID: "PAID",
  PAYED: "PAYED",
  UNPAID: "UNPAID",
  NOT_PAYED: "NOT_PAYED",
  PROCESS: "PROCESS",
};
